export const isProductSaved = (state, productId) =>
  state.savedItems.savedProducts.includes(productId) ||
  state.savedItems.summary.includes(productId);
